import React from 'react';

export default class AudioMeter extends React.Component {
    
    state = {
        volume: 0
    }

    listeners = []

    componentDidMount() {
        this.listeners.push(window.sdk.event().on('audioMeter' + this.props.meterId, (volume) => {           
            this.setState({
                volume
            })
        }));
    }

    componentWillUnmount() {
        for (var i in this.listeners) {
          this.listeners[i]();
        }      
    }

    render() {
        const { vertical } = this.props;
        return (
            <div className={'audio-meter-container' + (vertical ? ' audio-meter-container--vertical' : '')}>
                {(!vertical) && <div className={'audio-meter-inner'} style={{ width: (this.state.volume * 5) + '%'  }}></div>}
                {vertical && <div className={'audio-meter-inner'} style={{ height: (this.state.volume * 5) + '%'  }}></div>}
            </div>
        )
    }

}
